import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { resetPassword, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const { error: resetError } = await resetPassword(email);
      if (resetError) {
        throw resetError;
      }
      setMessage('OTP sent to your email. Redirecting to reset password page...');
      setIsSubmitted(true);
      
      // Redirect to reset password page with email
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 2000);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to send reset email');
    }
  };

  if (isSubmitted) {
    return (
      <div className="pen-screen flex items-center justify-center px-5 py-8">
        <div className="pen-card w-full max-w-md border-t-[3px] border-t-sw-yellow text-center">
          <h1 className="pen-title">OTP Sent!</h1>
          <p className="pen-lede">
            We&apos;ve sent a 6-digit OTP code to{' '}
            <strong className="text-white">{email}</strong>
          </p>
          <p className="text-xs text-sw-muted mb-4">
            You&apos;ll be redirected to enter the OTP and set your new password.
          </p>
          {message && <div className="pen-success mb-4 text-left">{message}</div>}
          <Link to="/login" className="pen-link">
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pen-screen flex items-center justify-center px-5 py-8">
      <div className="pen-card w-full max-w-md border-t-[3px] border-t-sw-yellow">
        <div className="text-center mb-5">
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center h-10 px-3.5 bg-sw-yellow text-black font-black text-sm tracking-[0.1em] uppercase rounded-sm"
          >
            HYROX
          </Link>
          <p className="mt-3 text-[10px] tracking-[0.14em] uppercase text-sw-muted-2 font-mono font-light">
            Penalty Logger
          </p>
        </div>

        <h1 className="pen-title">Reset your password</h1>
        <p className="pen-lede">
          Enter your email address and we&apos;ll send you a link to reset your password.
        </p>

        {error && <div className="pen-error mb-4">{error}</div>}
        {message && <div className="pen-success mb-4">{message}</div>}

        <form className="space-y-3" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email-address" className="pen-label">
              Email address
            </label>
            <input
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="pen-input"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" disabled={loading} className="pen-btn-primary w-full">
            {loading ? 'Sending...' : 'Send reset instructions'}
          </button>
        </form>

        <Link to="/login" className="pen-link block mt-4">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
